module.exports = __webpack_public_path__ + "static/media/reminder.6ccd2c72.svg";